export const randomInt = (max: number = 100) => Math.floor(Math.random() * Math.floor(max));
export default randomInt;
